import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_3 = {
  key: 1,
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["data-bs-target", "aria-controls"]
const _hoisted_6 = { class: "table table-bordered table-striped table-hover p-0 m-0" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "p-0 m-0" }
const _hoisted_9 = { class: "activated" }
const _hoisted_10 = ["id", "aria-labelledby"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            class: "spinner-grow text-primary",
            role: "status"
          }, null, -1)
        ])))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.listas.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listas, (lista, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "accordion-item",
              key: index
            }, [
              _createElementVNode("h2", {
                class: "accordion-header",
                id: 'headingTwo' + index
              }, [
                _createElementVNode("button", {
                  class: "accordion-button collapsed",
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '#collapseTwo' + index,
                  "aria-expanded": "false",
                  "aria-controls": 'collapseTwo' + index
                }, [
                  _createElementVNode("table", _hoisted_6, [
                    _createElementVNode("thead", _hoisted_7, [
                      _createElementVNode("tr", _hoisted_8, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dadosTabela, (dado) => {
                          return (_openBlock(), _createElementBlock("th", {
                            scope: "col",
                            class: "w-100px p-0 m-0",
                            key: dado.campo
                          }, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(lista[dado.campo]), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ], 8, _hoisted_5)
              ], 8, _hoisted_4),
              _createElementVNode("div", {
                id: 'collapseTwo' + index,
                class: "accordion-collapse collapse",
                "aria-labelledby": 'headingTwo' + index,
                "data-bs-parent": "#accordionExample"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _renderSlot(_ctx.$slots, "tabelaaccordion", {
                    tabelaaccordion: lista,
                    id: 'slot' + index
                  }, undefined, true)
                ])
              ], 8, _hoisted_10)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[1] || (_cache[1] = [
          _createElementVNode("h3", { class: "text-center" }, "Nenhum Registro Encontrado", -1)
        ])))
  ]))
}